import { HTMLAttributes } from 'react'
import cl from 'classnames'

import { Menu } from '@services/api/menus'

import { BoxedContent } from '@components/boxed-content'
import { Header } from '@components/header'
import { AdConfigProps, SponsorBanner } from '@components/sponsor-banner'
import { Footer } from '@components/footer'
import { useWindowDimensions } from '@hooks/use-window-dimensions'
import { useRouter } from 'next/router'

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  mainMenus?: Menu[]
  footerMenus1?: Menu[]
  footerMenus2?: Menu[]
  sponsorKeyword?: string
  ad?: AdConfigProps
  title?: string
  logoHeading?: boolean
  logoUrl?: string
}

export const LayoutHome = ({
  children,
  mainMenus,
  footerMenus1,
  footerMenus2,
  title,
  logoHeading,
  logoUrl,
  ad
}: LayoutProps) => {
  const { pathname } = useRouter()
  const { width } = useWindowDimensions()

  return (
    <>
      <BoxedContent>
        <div className="mt-20">
          <SponsorBanner config={ad} />
        </div>
      </BoxedContent>
      <div
        id="snap-div"
        className={cl('scroll-smooth font-myriad antialiased', {
          // Removido h-screen overflow-y-scroll para permitir scroll natural na home
          'snap-y snap-mandatory':
            width >= 1280 &&
            pathname.includes('empresa-de-projeto-de-energia-solar')
          // Removido pathname === '/' para permitir scroll normal na home
        })}
      >
        <Header
          menus={mainMenus}
          logoUrl={logoUrl}
          title={title}
          logoHeading={logoHeading}
          isFixed={true}
        />
        <main className="w-full flex flex-col scroll-smooth">{children}</main>
        <Footer
          menuFooter1={footerMenus1}
          menuFooter2={footerMenus2}
          hasSnap={pathname.includes('empresa-de-projeto-de-energia-solar')}
        />
        {/* Remover snap-start div para home */}
        {pathname.includes('empresa-de-projeto-de-energia-solar') && (
          <div className="snap-start"></div>
        )}
      </div>
    </>
  )
}
